import {
  bindIsArrayOf,
  ensure,
  isNullOrUndefined,
  isNumber,
  isObject,
  isString,
  isValidInterface,
} from '@utils/guards';
import { transformNumber } from '@utils/numbers';

import type { ITableBaseRecordType } from '../components/VTable/types';
import type {
  ITableDataResponseAdditional,
  ITableDataResponseBase,
  ITableListAsObject,
  ITableListAsObjectValue,
} from '../types';

export function localeKeyTypeGuard(value: unknown): value is ITableDataResponseBase {
  return isValidInterface(value, {
    locale_key: isString,
  });
}

export function paginationTypeGuard(value: unknown): value is ITableDataResponseAdditional {
  return isValidInterface(value, {
    start_row_num: isNumber,
    end_row_num: isNumber,
    total_entries: isNumber,
    total_pages: isNumber,
  });
}

export function attributesTypeGuard<ListType>(value: unknown): value is ITableListAsObjectValue<ListType> {
  return isValidInterface(value, {
    attributes: isObject,
  });
}

export function listDataTypeGuard<ListType>(value: unknown): value is ITableListAsObject<ListType> {
  return isValidInterface(value, {
    data: bindIsArrayOf(attributesTypeGuard),
  });
}

export function itemIdTypeGuard<ListType>(value: unknown): value is ListType {
  return isValidInterface(value, {
    id: [isNumber, isNullOrUndefined],
  });
}

export function ensureList<ListType>(value: unknown): ListType[] {
  return ensure<ReturnType<typeof bindIsArrayOf<ListType>>, ListType>(bindIsArrayOf<ListType>(itemIdTypeGuard), value);
}

export function ensureListAsObject<ListType>(value: unknown): ITableListAsObject<ListType> {
  return ensure<typeof listDataTypeGuard<ListType>, ITableListAsObject<ListType>>(listDataTypeGuard, value);
}

export function isBaseRecordTypeGuard(value: unknown): value is ITableBaseRecordType {
  return itemIdTypeGuard<ITableBaseRecordType>(value);
}

export function ensureBaseRecord(value: unknown): ITableBaseRecordType {
  return ensure<typeof isBaseRecordTypeGuard, ITableBaseRecordType>(isBaseRecordTypeGuard, value);
}

export function formatTotalColumnResult(value: number | null, columnName: string): string {
  return (value != null && columnName !== 'transaction_date_for_reports' ? transformNumber(String(value)) : '–');
}
